import React from 'react';
import { Modal, Button } from 'antd';
import './showModal.css';

const { Fragment } = React;

class ShowModal extends React.PureComponent {
  state = { visible: false };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { content, keys, type } = this.props;
    let list = null;
    if (keys && keys.length > 0) {
      if (type === 'serviceTypes') {
        list =
          content &&
          content
            .filter(item => keys.includes(item.serviceTypeKey))
            .map(item => ({
              key: item.serviceTypeKey,
              name: item.serviceType,
            }));
      } else if (type === 'profiles') {
        list =
          content &&
          content
            .filter(item => keys.includes(item.profileId))
            .map(item => ({ key: item.profileId, name: item.userName }));
      }
    }
    return (
      <Fragment>
        <Button
          className={(content && 'selectedBtn') || 'selectOptionBtn'}
          onClick={this.showModal}
        >
          Посмотреть
        </Button>
        <Modal
          title={this.props.title}
          visible={this.state.visible}
          onOk={this.handleOk}
          className="cardVehiclShowModal"
          centered={true}
          onCancel={this.handleCancel}
        >
          {list && list.map(({ key, name }) => <p key={key}>{name}</p>)}
        </Modal>
      </Fragment>
    );
  }
}

export default ShowModal;
